"use client";
import * as React from "react";
import { RadioProps } from "../types";
import styles from "./index.module.css";
import Spacer from "../Spacer/index";

function Radio(props: RadioProps) {
  function id() {
    return props.value.replace(/ /g, "");
  }

  return (
    <div className={styles.radioDiv}>
      <input
        type="radio"
        value={props.value}
        checked={props.checked}
        name={props.name}
        id={id()}
        className={styles.radio}
        onChange={(event) => props.handleInputChange(event)}
      />
      <Spacer x={1} />
      <label htmlFor={id()}>{props.children}</label>
    </div>
  );
}

export default Radio;
